
import KeySquare from "../../../assets/outline/KeySquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function KeySquareIcon({ className, dataTestid = "KeySquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <KeySquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
